import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { Radicacion, RadicadoCita, Const, ModificacionDocumento } from "@app/shared";
import { HttpErrorHandlingService, EndpointService } from "@app/core";
import { environment } from "@env/environment";


/**
 * Modelo de las dependencias
 *
 * @export
 * @interface Dependencie
 */
 export interface Dependencie {
  id: number;
  nombre: string;
  descripcion: string;
  codigo: number;
}

export interface GenerateRadication {
  clasificacion_documentos: number;
  documento_cita: string;
  fecha: Date;
  folios: number;
  id: number;
  id_documento_cita: number;
  radicado: string;
  id_dependencia: number;
  tipo_documental?: number | string;
}

export interface Sticker {
  id?: number;
  nombre?: string;
  tipo_documental?: TipoDocumental;
  imprimir?: boolean;
}

export interface TipoDocumental {
  id: number;
  nombre: string;
  codigo: string;
  expediente: boolean;
  subserie: number;
}

export interface Responsable {
  id: number;
  first_name: string;
  last_name: string;
}

export interface DocumentAnnulation {
  id?: number;
  tramite: number;
  documento: number;
  motivo: string;
  fecha: Date;
  responsable?: Responsable;
}

export interface previewStickerStructure {
  label: string,
  alias: string,
  mostrar: boolean,
  orden: number,
  posicion: number
}

export interface previewSticker {
  estructura: previewStickerStructure[];
  valores: any;
}

@Injectable()
export class SpecialRadicationDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private hehs: HttpErrorHandlingService,
    private api: EndpointService
  ) {}

  generateRadication(formData: any): Promise<GenerateRadication> {
    return new Promise((resolve, reject) => {
      this.http
        .skipErrorHandler()
        .post<GenerateRadication>(this.api.get("generateRadicationCita"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            this.toastr.success(`Documento radicado correctamente`, "Operación exitosa");
            resolve(res.body);
          },
          (err) =>
            this.hehs.error(err, () => {
              if (err.status !== 401 && err.status !== 403) {
                if (err.error["message"] && err.status !== 500) {
                  this.toastr.error(err.error["message"], "Error en radicación");
                } else if (err.error["Error"] && err.status !== 500) {
                  this.toastr.error(err.error["Error"], "Error en radicación");
                } else if (err.status !== 500) {
                  this.toastr.error("Lo sentimos ha ocurrido un error inesperado", "Error en radicación");
                }
              }
              reject(err);
            })
        );
    });
  }

  /**
   *Servicio encragado de subir los archivos
   *
   * @param {FormData} formData
   * @return {*}  {Observable<any>}
   * @memberof SpecialRadicationDataService
   */
  uploadFile(formData: FormData): Observable<any> {
    return new Observable((obs) => {
      this.http
        .post(this.api.get("docsInstance"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 201) {
              obs.next(res.body);
              this.toastr.success("Archivos subidos correctamente.", "Operación exitosa");
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }

  /**
   *Obitnen rótulos por tipo documental
   *
   * @param {number} id
   * @return {*}  {Observable<Sticker[]>}
   * @memberof SpecialRadicationDataService
   */
  getStickers(id: number): Observable<Sticker[]> {
    return new Observable((obs) => {
      this.http.get<Sticker[]>(this.api.get("sticker_document", [id])).subscribe(
        (sticker) => {
          obs.next(sticker);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }

  downloadSticker(id_tarea: number, sticker_id: number, clasificacion?: number): Observable<any> {
    let data = {
      tarea: id_tarea,
      clasificacion: clasificacion,
      sticker_id: sticker_id,
    };
    return new Observable((obs) => {
      this.http
        .post<any>(this.api.get("generateStickerDoc"), data, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 200 || res.status === 201) {
              obs.next(res);
              this.toastr.success("Rótulo descargado exitosamente.", "Operación exitosa");
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }

  downloadDocument(id_documento: number, ingoreMessage:boolean = false): Observable<any> {
    return new Observable((obs) => {
      this.http
        .get<any>(this.api.get("docsInstance", [id_documento]))
        .subscribe(
          (res) => {
            if (res) {
              obs.next(res);
              if (!ingoreMessage){
                this.toastr.success("Documento descargado correctamente.", "Operación exitosa");
              }
            } else {
              obs.next({});
            }
          },
          (err) =>
            this.hehs.error(err, () => {
              obs.error(err);
            })
        );
    });
  }

  /**
   *Anular radicado
   *
   * @memberof SpecialRadicationDataService
   */
  annulation(id_task: number, id_document: number, annulation: string, date: Date, reason: string): Observable<any>{
    let formData = {
      id_tarea: id_task,
      id_documento: id_document,
      anulacion: annulation,
      motivo: reason
    }
    return new Observable((obs) => {
      this.http
        .post(this.api.get("annul"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            if (res.status === 201 || res.status === 200) {
              obs.next(res.body);
              this.toastr.success("Radicado anulado correctamente.", "Operación exitosa");
            }else if (res.status === 400 || res.status === 401) {
              this.toastr.warning("No se pudo anular el radicado.", "Error en la operación");
            }
             else {
              obs.next({});
            }
          },
          (err) => {
            if (err.status === 400 || err.status === 401) {
              this.toastr.warning(err.error, "Error en la operación");
            }else {
              this.hehs.error(err, () => {
                obs.error(err);
              })
            }
          }
        );
    });
  }

  /**
   *Consulta si el documento tiene anulación
   *
   * @param {number} id_documento
   * @return {*} 
   * @memberof SpecialRadicationDataService
   */
  getAnnulation(id_documento: number): Observable<DocumentAnnulation>{
    return new Observable((obs) => {
      this.http.get<DocumentAnnulation>(this.api.get("annul", [id_documento])).subscribe(
        (annul) => {
          obs.next(annul);
        },
        (err) => {
          obs.error(err);
        }
      );
    });
  }

  
   /**
    * Obtiene las dependencias del sistema
    *
    * @return {*}  {Observable<any>}
    * @memberof SpecialRadicationDataService
    */
   getDependencies(): Observable<any> {
    return new Observable((obs) => {
      this.http
        .get<any>(this.api.get("searchDependencie"), {
          observe: "response",
        })
        .subscribe(
          (res) => {
            obs.next(res.body);
          },
          (err) => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error["message"], "Fallo en la consulta de datos de dependencias");
            }
            obs.error(err);
          }
        );
    });
  }

  getPreviewRadication(id_tarea: number, preview_id: number, type_document_id: number): Observable<previewSticker> {
    let formData = {
      preview_id: preview_id,
      task_id: id_tarea,
      type_document: type_document_id
    }
    return new Observable((obs) => {
      this.http
        .skipErrorHandler()
        .post<previewSticker>(this.api.get("previewStickerDocument"), formData, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            // this.toastr.success(`Documento radicado correctamente`, "Operación exitosa");
            obs.next(res.body);
          },
          (err) =>
            this.hehs.error(err, () => {
              if (err.status !== 401 && err.status !== 403) {
                if (err.error["message"] && err.status !== 500) {
                  this.toastr.error(err.error["message"], "Error en la carga de vista de radicado");
                } else if (err.error["Error"] && err.status !== 500) {
                  this.toastr.error(err.error["Error"], "Error en la carga de vista de radicado");
                } else if (err.status !== 500) {
                  this.toastr.error("Lo sentimos ha ocurrido un error inesperado", "Error en la carga de vista de radicado");
                }
              }
              obs.error(err);
            })
        );
    });
  }

  /**
   * Servicio que genera el documento
   *
   * @param {*} data
   * @returns {Observable<any>}
   * @memberof SpecialRadicationDataService
   */
  generateDocument(data: any, ingoreMessage:boolean = false): Observable<any> {
    return new Observable((obs) => {
      this.http
        .skipErrorHandler()
        .post(this.api.get("documentGeneration"), data, {
          observe: "response",
        })
        .subscribe(
          (res) => {
            obs.next(res.body);
            if (!ingoreMessage){
              this.toastr.success("Documento generado correctamente.", "Operación exitosa");
            }
          },
          (err) => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error["message"], "Error en radicación");
            }
            obs.error(err);
          }
        );
    });
  }

    /**
   * servicio para descargar los archivos
   *
   * @param {number} idDocumento
   * @returns {Observable<any>}
   * @memberof SpecialRadicationDataService
   */
    dowloadModifyFile(idDocumento: number): Observable<any> {
      return new Observable(obs => {
        this.http
          .skipErrorHandler()
          .get(this.api.get('modifyDocument', [idDocumento]), {
            observe: 'response'
          })
          .subscribe(
            res => {
              obs.next(res.body);
            },
            err => {
              if (err.status !== 401 && err.status !== 403) {
                this.toastr.error(err.error['message'], 'Fallo de descarga');
              }
              obs.error(err);
            }
          );
      });
    }
  
  
     /**
     *Obtiene el historial de modificaciones de un documento
     *
     * @param {number} id
     * @return {*}  {Observable<ModificacionDocumento[]>}
     * @memberof SpecialRadicationDataService
     */
     getHistoryModifyDocument(id: number): Observable<ModificacionDocumento[]> {
      return new Observable((obs) => {
        this.http.get<ModificacionDocumento[]>(this.api.get("historyModifyDocument", [id])).subscribe(
          (history: any) => {
            obs.next(history);
          },
          (err) => {
            obs.error(err);
          }
        );
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/special-radication/shared/special-radication.data.service.ts